const ReactAnimatedNumber = require("react-animated-number");

const propTypes = {
  value: React.PropTypes.number.isRequired,
  duration: React.PropTypes.number,
  precision: React.PropTypes.number,
  formatter: React.PropTypes.func
};

const defaultProps = {
  duration: 1000,
  precision: 0,
  formatter: function(value) { return value; }
};

function AnimatedValue({ value, duration, precision, formatter }) {
  return (
    <ReactAnimatedNumber
      value={value}
      duration={duration}
      stepPrecision={precision}
      formatValue={formatter}
    />
  )
}

AnimatedValue.propTypes = propTypes;
AnimatedValue.defaultProps = defaultProps;

module.exports = AnimatedValue;



// WEBPACK FOOTER //
// ./app/shared/components/AnimatedValue/animated-value.jsx